import React, { useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import './ResetPassword.css';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // ✅ Get token from URL

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (!token) {
      setMessage({ text: '❌ Invalid or missing token.', type: 'error' });
      return;
    }

    if (newPassword.length < 6) {
      setMessage({ text: '❌ Password must be at least 6 characters long.', type: 'error' });
      return;
    }

    setLoading(true); // ✅ Prevents multiple submissions

    try {
      const response = await axios.post('https://wholeness-forward.onrender.com/api/auth/reset-password', {
        token,
        newPassword, // ✅ Ensure newPassword is sent correctly
      });

      setMessage({ text: response.data.message, type: 'success' });
      setNewPassword('');
    } catch (error) {
      setMessage({
        text: error.response?.data?.message || '❌ Failed to reset password. Please try again.',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-container">
      <form className="reset-password-card" onSubmit={handlePasswordReset}>
        <h1>Reset Password</h1>
        <p className="reset-instructions">Enter your new password below.</p>
        
        <input
          type="password"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          className="reset-password-input"
        />

        <button type="submit" className="reset-password-button button" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>

        {message.text && <div className={`reset-message ${message.type}`}>{message.text}</div>}
      </form>
    </div>
  );
};

export default ResetPassword;
